import { IUpdateAssistenciaRegistroAtendimentoUseCase } from "../../../presentation/useCases/update/update_assistencia_registro_atendimento_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateAssistenciaRegistroAtendimentoUseCase
 */

export class UpdateAssistenciaRegistroAtendimentoUseCase implements IUpdateAssistenciaRegistroAtendimentoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async updateAssistenciaRegistroAtendimento(
    idAssistenciaTecnica: number,
    idAssistenciaAtendimento: number,
    tipo: number,
    descricao: string,
    dataInicio: Date | null,
    dataTermino: Date | null,
    observacoes: string | null,
    responsavelConstrutora: number | null,
    responsavelCliente: string | null,
  ): Promise<void> {
    await this.repository.updateAssistenciaRegistroAtendimento(
      idAssistenciaTecnica,
      idAssistenciaAtendimento,
      tipo,
      descricao,
      dataInicio,
      dataTermino,
      observacoes,
      responsavelConstrutora,
      responsavelCliente,
    );
  }
}
